import { useTranslations } from "use-intl";
import { ColumnType } from "antd/es/table";
import { FC } from "react";

export function useOptionsColumn<T>({
  Options,
  hidden = false,
}: {
  Options: FC<{ record: T }>;
  hidden?: boolean;
}): ColumnType<T> {
  const t = useTranslations("Common");

  return {
    key: "options",
    title: t("Options"),
    width: 100,
    align: "center",
    fixed: "right",
    hidden,
    render: (_, record) => <Options record={record} />,
  };
}
